import styled from 'styled-components/native'

export const SelectPersonContainer = styled.View<{
  highlightcolor: string
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px 6px 3px 8px;
`

export const LConnector = styled.View<{
  highlightcolor: string
}>`
  width: 12px;
  height: 10px;
  border-left-width: 1.5px;
  border-bottom-width: 1.5px;
  border-left-color: ${({ highlightcolor }) => highlightcolor || '#fff'};
  border-bottom-color: ${({ highlightcolor }) => highlightcolor || '#fff'};
  border-bottom-left-radius: 4px;
  margin-right: 7px;
  align-self: flex-start;
`

export const SelectPersonText = styled.Text<{
  highlightcolor: string
}>`
  color: ${({ highlightcolor }) => highlightcolor || '#fff'};
`
